import React from 'react';
import axios from 'axios';
import html2canvas from 'html2canvas';

const Detailspdf = ({ data, soilData, hasDrawnShape, rectangleBounds }) => {
  const handleExportPDF = async () => {
    try {
      // Capture screenshots of key sections
      const screenshots = {};
      
      // Capture map screenshot if it exists
      const mapElement = document.querySelector('.leaflet-container');
      if (mapElement) {
        const mapCanvas = await html2canvas(mapElement, {
          useCORS: true,
          scale: 0.5, // Reduced quality to decrease file size
          backgroundColor: '#ffffff'
        });
        screenshots.map = mapCanvas.toDataURL('image/jpeg', 0.8); // JPEG format with 80% quality
      }
      
      // Capture location details if it exists
      const locationElement = document.querySelector('[data-section="location-details"]');
      if (locationElement) {
        const locationCanvas = await html2canvas(locationElement, {
          scale: 1, // Normal quality
          backgroundColor: '#ffffff'
        });
        screenshots.locationDetails = locationCanvas.toDataURL('image/jpeg', 0.8);
      }
      
      // Capture weather and soil data if it exists
      const weatherSoilElement = document.querySelector('[data-section="weather-soil-data"]');
      if (weatherSoilElement) {
        const weatherSoilCanvas = await html2canvas(weatherSoilElement, {
          scale: 1, // Normal quality
          backgroundColor: '#ffffff'
        });
        screenshots.weatherSoilData = weatherSoilCanvas.toDataURL('image/jpeg', 0.8);
      }
      
      // Capture recommendations if it exists
      const recommendationsElement = document.querySelector('[data-section="recommendations"]');
      if (recommendationsElement) {
        const recommendationsCanvas = await html2canvas(recommendationsElement, {
          scale: 1, // Normal quality
          backgroundColor: '#ffffff'
        });
        screenshots.recommendations = recommendationsCanvas.toDataURL('image/jpeg', 0.8);
      }
      
      // Capture satellite analysis if it exists
      const satelliteElement = document.querySelector('[data-section="satellite-soil-analysis"]');
      if (satelliteElement) {
        const satelliteCanvas = await html2canvas(satelliteElement, {
          scale: 0.8, // Reduced quality
          backgroundColor: '#ffffff'
        });
        screenshots.satelliteAnalysis = satelliteCanvas.toDataURL('image/jpeg', 0.8);
      }
      
      // Capture weather and soil chart if it exists
      const weatherChartElement = document.querySelector('[data-section="weather-soil-chart"]');
      if (weatherChartElement) {
        const weatherChartCanvas = await html2canvas(weatherChartElement, {
          scale: 0.7, // Reduced quality
          backgroundColor: '#ffffff'
        });
        screenshots.weatherChart = weatherChartCanvas.toDataURL('image/jpeg', 0.8);
      }
      
      // Capture conclusion summary if it exists
      const conclusionElement = document.querySelector('[data-section="conclusion-summary"]');
      if (conclusionElement) {
        const conclusionCanvas = await html2canvas(conclusionElement, {
          scale: 0.8, // Reduced quality
          backgroundColor: '#ffffff'
        });
        screenshots.conclusion = conclusionCanvas.toDataURL('image/jpeg', 0.8);
      }

      // Prepare data for PDF generation with proper coordinate extraction
      const extractCoordinates = () => {
        // Try multiple possible sources for coordinates
        if (data.latitude && data.longitude) {
          return { lat: data.latitude, lon: data.longitude };
        }
        if (data.coordinates && Array.isArray(data.coordinates) && data.coordinates.length >= 2) {
          return { lat: data.coordinates[0], lon: data.coordinates[1] };
        }
        if (rectangleBounds && rectangleBounds.length >= 2) {
          // Use center of rectangle bounds
          const centerLat = (rectangleBounds[0][0] + rectangleBounds[1][0]) / 2;
          const centerLon = (rectangleBounds[0][1] + rectangleBounds[1][1]) / 2;
          return { lat: centerLat, lon: centerLon };
        }
        return { lat: null, lon: null };
      };

      const coords = extractCoordinates();

      const pdfData = {
        location: data.location || 'Custom Location',
        location_type: data.location_type || 'rectangle',
        latitude: coords.lat,
        longitude: coords.lon,
        recommended_crops: data.recommended_crops || [],
        recommended_fertilizers: data.recommended_fertilizers || [],
        rainfall_mm: data.rainfall_mm,
        temperature_c: data.temperature_c,
        soil_moisture: data.soil_moisture,
        suitability: data.suitability,
        soil_ph: data.soil_ph || (data.additional_info ? data.additional_info.soil_ph : null),
        humidity: data.humidity || (data.additional_info ? data.additional_info.humidity : null),
        wind_speed: data.wind_speed || (data.additional_info ? data.additional_info.wind_speed : null),
        crop_season: data.crop_season || (data.additional_info ? data.additional_info.crop_season : null),
        irrigation_requirement: data.irrigation_requirement || (data.additional_info ? data.additional_info.irrigation_requirement : null),
        ndvi: soilData.ndvi,
        evi: soilData.evi,
        ndwi: soilData.ndwi,
        bsi: soilData.bsi,
        savi: soilData.savi,
        ndmi: soilData.ndmi,
        msi: soilData.msi,
        hasDrawnShape,
        rectangleBounds,
        screenshots // Include screenshots in the data
      };

      // Send request to backend to generate PDF
      const response = await axios.post(`${process.env.REACT_APP_API_URL || (process.env.REACT_APP_API_URL || (process.env.REACT_APP_API_URL || "http://localhost:5001"))}/api/generate-report`, pdfData, {
        responseType: 'blob' // Important for handling binary data
      });

      // Create a URL for the PDF blob
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `crop-report-${Date.now()}.pdf`);
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error exporting PDF:', error);
      alert('Error exporting PDF report');
    }
  };

  return (
    <div style={{ marginTop: '20px', textAlign: 'center' }}>
      <button
        onClick={handleExportPDF}
        style={{
          padding: '12px 24px',
          backgroundColor: '#28a745',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
          fontSize: '16px',
          fontWeight: '600'
        }}
      >
        📄 Export Detailed Report (PDF)
      </button>
    </div>
  );
};

export default Detailspdf;
